require("./group_webhook_management")
import { APIKeys } from "./api_keys";

export class IntegrationManagement extends HTMLElement {
  constructor(data, is_admin) {
    super();
    this.data = data;
    this.is_admin = is_admin;
  }

  connectedCallback() {
    this.innerHTML =
    `
    <style>
      #tablist4 {
        margin: 0 0 20px 0 !important;
        border: none !important;
      }
    </style>
    <div class="row">
      <div class="nav nav2-tabs nav2-subtabs page-content-wrap" role="tablist" id='tablist4'>
        <a class="active" href="#integration_templates_tab" role="tab" data-toggle="tab">Integration Templates</a>
        <a href="#api_keys_tab" role="tab" data-toggle="tab">API Keys</a>
      </div>
      <div class="panel-body tab-content">
        <div class="page-content-wrap nav2-subtabs-item  tab-pane active" id="integration_templates_tab">
          <group-webhooks></group-webhooks>
        </div>
        <div class="page-content-wrap nav2-subtabs-item  tab-pane" id="api_keys_tab">
          
        </div>
      </div>
    </div>
    `;

    $(this).find(".nav2-subtabs a").on("click",function(e){
      $(this).find(".nav2-subtabs a").removeClass("active");
      $(e.target).addClass("active");
      $(this).find(".nav2-subtabs-item").removeClass("active");
      $($(e.target).attr("href")).addClass("active");
      return false;
    }.bind(this));

    this.querySelector('#api_keys_tab').appendChild(new APIKeys(this.data, this.is_admin));
  }
}

customElements.define('integration-management', IntegrationManagement)